export function setupMaestro() {
  if (process.env.EXPO_PUBLIC_USE_MOCK === 'true') {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { setupMocks } = require('./mockApi');
    setupMocks();
  }
}
